export const chipColorMap = {
    draft: 'primary',
    mobilizing: 'success',
    inProgress: 'success',
    complete: 'success',
    closed: 'default',
};
